import { IDescriptionQualityResult } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/commonComponents/editorComponents/components/descriptionQuality/models'

export type IDescriptionQualityCheckResult = IDescriptionQualityResult

export enum CopyValidationIssue {
  NameRequired = 'nameRequired',
  NameTooLong = 'nameTooLong',
  DescriptionRequired = 'descriptionRequired',
  DescriptionQuality = 'descriptionQuality',
  DescriptionQualityUnavailable = 'descriptionQualityUnavailable',
  StrategicInitiative = 'strategicInitiative',
  BusinessUnit = 'businessUnit',
  BusinessPriorities = 'businessPriorities',
  Period = 'period',
  Status = 'status',
  Funding = 'funding',
  FinancialTarget = 'financialTarget',
  ActivityType = 'activityType',
}

export type CopyValidationStatus = 'queued' | 'validating' | 'valid' | 'invalid'

export interface ICopyValidationResult {
  isValid: boolean
  issues: CopyValidationIssue[]
  descriptionQuality: IDescriptionQualityCheckResult | null
}

export interface ICopyValidationState extends ICopyValidationResult {
  status: CopyValidationStatus
}
